export default [
  {
    path: '/admin/available-schedules',
    name: 'table-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/booking/available-schedule')
  }
]
